import React from "react";
import './Containers.scss';

export const AppContainer = (props: { children: React.ReactNode }) => {
    return <div className="centered-container">
        <div className="main-content">
            {props.children}
        </div>
    </div>
}